// extracted by mini-css-extract-plugin
export default {"error-text":"SubAssetType_error-text__VlQLb","section-title":"SubAssetType_section-title__x8EZG","item-title":"SubAssetType_item-title__3MJ8F"};